<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_creditProof"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('creditProof_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('creditProof_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      show-footer
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      :loading="loading"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderNumber"
          title="运输单号"
          min-width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderNumber"
            placeholder="请输入运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="issueId" title="贷款编码" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.issueId"
            placeholder="请输入贷款编码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="batchId" title="批次号" min-width="200" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.batchId"
            placeholder="请输入批次号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="放款状态"
          :formatter="formatterStatus"
          min-width="150"
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="resultMsg"
          title="接口回调信息"
          min-width="300"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.resultMsg"
            placeholder="请输入接口回调信息"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="driverName" title="收款人" min-width="150" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入收款人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverPhone"
          title="收款人手机号"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverPhone"
            placeholder="请输入收款人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverAmt"
          title="收款金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="listQuery.driverAmtMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="listQuery.driverAmtMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isWsShare"
          title="是否清分"
          :formatter="
            ({ cellValue }) => {
              if (cellValue == 1) {
                return '是';
              } else {
                return '否';
              }
            }
          "
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isWsShare"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in isWsShareOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLeaderName"
          title="车队长"
          min-width="150"
          :formatter="
            ({ cellValue, row, column }) => {
              if (row.isWsShare == 1) {
                return cellValue;
              } else {
                return '';
              }
            }
          "
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverLeaderName"
            placeholder="请输入车队长名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverLeaderPhone"
          title="车队长手机号"
          min-width="150"
          :formatter="
            ({ cellValue, row, column }) => {
              if (row.isWsShare == 1) {
                return cellValue;
              } else {
                return '';
              }
            }
          "
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverLeaderPhone"
            placeholder="请输入车队长手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="leaderAmt"
          title="车队长金额"
          min-width="200"
          sortable
          :formatter="
            ({ cellValue, row, column }) => {
              if (row.isWsShare == 1) {
                return cellValue;
              } else {
                return '';
              }
            }
          "
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model.number="listQuery.leaderAmtMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model.number="listQuery.leaderAmtMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loanTime"
          title="发行时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.loanTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'loanTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="realizeTime"
          title="放款时间"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.realizeTimeRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'realizeTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="120" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              (getLimit('creditProof_loan_button') && scope.row.status == 3) ||
                (isAdmin && scope.row.status == -2)
            "
            class="item"
            effect="dark"
            content="放款"
            placement="top"
          >
            <vxe-button type="text" @click="funcLoan(scope.row)">
              <i class="el-icon-wallet" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('creditProof_reload_button') && tryToNext(scope.row)"
            class="item"
            effect="dark"
            content="刷新凭证状态"
            placement="top"
          >
            <vxe-button type="text" @click="funcReload(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('creditProof_publish_button') &&
                scope.row.status == 1 &&
                scope.row.publishUrl
            "
            class="item"
            effect="dark"
            content="发行凭证"
            placement="top"
          >
            <vxe-button type="text" @click="publishProof(scope.row.publishUrl)">
              <i class="el-icon-s-unfold" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('creditProof_goback_button') &&
                (scope.row.status == -1 || scope.row.status == 2)
            "
            class="item"
            effect="dark"
            content="撤销打款"
            placement="top"
          >
            <vxe-button type="text" @click="funcRollBack(scope.row)">
              <i class="el-icon-refresh-left" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelLoanFlag"
      title="放款至网商余额"
      width="600"
      height="400"
      resize
    >
      <compLoan
        ref="loanRef"
        @fatherLoanMethod="fatherLoan"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compLoan from "./components/creditProofLoan.vue";
import request from "@/utils/request";
export default {
  name: "CreditProofList",
  components: {
    compLoan
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      modelLoanFlag: false,
      copy: false,
      exportObj: {
        exportUrl: "/ntocc-tms-api/creditProof/exportCreditProof", //导出接口
        name: "放款管理"
      },
      listQuery: {
        loanTimeRange: "",
        realizeTimeRange: "",
        branchCode: "",
        name: "",
        phone: "",
        cardNo: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 机构列表
      branchList: this.$store.state.components.branchList,
      isWsShareOptions: [{ value: 0, label: "否" }, { value: 1, label: "是" }],
      statusOptions: [
        // { value: 0, label: '未获取' },
        // { value: 1, label: '获取中' },
        // { value: 2, label: '获取失败' },
        { value: 3, label: "待放款" },
        { value: 4, label: "放款中" },
        { value: 5, label: "放款失败" },
        { value: 6, label: "放款成功" },
        { value: 7, label: "待清分" },
        { value: 8, label: "清分中" },
        { value: 9, label: "已结清" },
        { value: 10, label: "已偿还" },
        // { value: -1, label: '凭证发行异常' },
        { value: -2, label: "放款异常" }
      ],
      isAdmin: false
    };
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin = partyType == "SUPER_ADMIN" || partyType == "PLAT_ADMIN";
    this.findList();
  },
  methods: {
    tryToNext(row) {
      switch (row.status) {
        case -1:
        case -2:
        case 1:
        case 2:
        case 4:
        case 5:
        case 7:
        case 8:
        case 10:
          return true;
        default:
          return false;
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "/ntocc-tms-api/creditProof",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 放款
    funcLoan(row) {
      this.$refs.loanRef.getInfo(row.code);
      this.modelLoanFlag = true;
    },
    // 重载凭证状态
    funcReload(row) {
      let code = row.code;
      if (code) {
        this.loading = true;
        request({
          url: "/ntocc-tms-api/maYiCreditFlow/reloadCreditIssue",
          method: "post",
          params: { code }
        })
          .then(response => {
            this.findList();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 撤销凭证打款
    funcRollBack(row) {
      let code = row.code;
      if (code) {
        this.loading = true;
        request({
          url: "/ntocc-tms-api/maYiCreditFlow/rollBackCreditIssue",
          method: "post",
          params: { code }
        })
          .then(response => {
            this.findList();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 发行凭证
    publishProof(publishUrl) {
      window.open(publishUrl);
    },
    // 详情方法
    funcDetail(params) {
      this.$refs.detailRef.getInfo(params);
      this.modelDetailFlag = true;
    },
    fatherLoan() {
      this.modelLoanFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "detail":
          this.modelDetailFlag = false;
          break;
        case "loan":
          this.modelLoanFlag = false;
          break;
        default:
      }
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    }
  }
};
</script>
<style></style>
